import { Component } from '@poa/core';
import { action, observable, Observer } from '@poa/state';
import React from 'react';
import DataTable from '../components/data-table/data-table';
import Navbar from '../components/navbar';
import { GeneralAccountModal } from '../components/account-modal/account-modal';
import RouteLoading from '../components/route-loading';
import TableFilter, { PageModeReports } from '../components/table-filter';
import { ACCESS_LEVEL } from '../store/auth/auth.constants';
import ReportFilterTooltip from '../components/profile-modal/report-search-filter-tooltip';
import ReportModal from '../components/profile-modal/report-search-modal';

class ReportsPage extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa

  filterBy = observable({
    'all': '',
    'index': '',
    'account_id': '',
    'name': '',
    'panels': [],
    'managers': [],
    'teamleads': [],
    'scouts': [],
    'operators': [],
    'account-managers': [],
    'levels': [],
    'nick': '',
    'email': ''
  });

  filterNames = observable({
    'all': 'По всем',
    'index': '№',
    'account_id': 'ID',
    'name': 'ФИО',
    'panels': 'Панель',
    'managers': 'Менеджер',
    'teamleads': 'Тимлид',
    'scouts': 'Скаут',
    'operators': 'Оператор',
    'levels': 'Уровень',
    'account-managers': 'ММ',
    'nick': 'Ник',
    'email': 'Email'
  });

  coreFilterNames = {
    'по всем': 'all',
    'panel': 'panels',
    'full_name': 'name',
    'manager': 'managers',
    'form_level': 'levels',
    'team_lead': 'teamleads',
    'scout': 'scouts',
    'account_manager': 'account-managers',
    'operator': 'operators',
    'nick': 'nick',
    'id': 'account_id',
    'number': 'index',
    'email': 'email'
  };

  reverseCoreFilterNames = {
    'panels': 'panel',
    'name': 'full_name',
    'managers': 'manager',
    'levels': 'form_level',
    'teamleads': 'team_lead',
    'operators': 'operator',
    'scouts': 'scout',
    'account-managers': 'account_manager',
    'nick': 'nick',
    'account_id': 'id',
    'index': 'number',
    'all': 'по всем',
    'email': 'email'
  };

  levelOptions = [
    { id: '1', title: '1' },
    { id: '2', title: '2' },
    { id: '3', title: '3' },
    { id: '4', title: '4' },
    { id: '5', title: '5' }
  ];

  localStateExample = {
    isModalOpened: false,
    isTableLoading: false,
    isReportModalOpened: false,
    selectedProfileId: null,
    pageMode: PageModeReports.reports,
    selectedOptions: [
      'all', 'panels', 'name', 'managers', 'teamleads', 'operators', 'levels', 'nick',
      'account_id', 'index', 'email'
    ],
    reportModalOptions: [
      { value: 'all', label: 'По всем' },
      { value: 'panels', label: 'Панель' },
      { value: 'name', label: 'ФИО' },
      { value: 'managers', label: 'Менеджер' },
      { value: 'teamleads', label: 'Тимлид' },
      { value: 'operators', label: 'Оператор' },
      { value: 'scouts', label: 'Скаут' },
      { value: 'account-managers', label: 'ММ' },
      { value: 'levels', label: 'Уровень' },
      { value: 'nick', label: 'Ник' },
      { value: 'account_id', label: 'ID' },
      { value: 'index', label: '№' },
      { value: 'email', label: 'Email' }],
    tooltipOpened: false,
    search: {
      filter_by: JSON.parse(JSON.stringify(this.filterBy)),
      reportFilters: [],
      status: 'active'
    }
  };

  constructor(props) {
    super(props);
    this.localState = observable(JSON.parse(
      (localStorage.getItem(`reportLocalState_${this.store.auth.currentHost}`))
    ) || this.localStateExample);
  }

  lastSorting = new Map();

  onModalClose = action(() => {
    this.localState.isModalOpened = false;
    this.localState.selectedProfileId = null;
  });

  onModalOpen = action(profileId => {
    this.localState.selectedProfileId = profileId;
    this.localState.isModalOpened = true;
  });

  onReportModalClose = action(() => {
    this.localState.isReportModalOpened = false;
    this.localState.tooltipOpened = true;
  });

  onReportModalOpen = action(profileId => {
    this.localState.isReportModalOpened = true;
    this.localState.tooltipOpened = false;
  });

  onSearchTooltipClose = action(() => {
    this.localState.tooltipOpened = false;
  });

  onSearchTooltipOpen = action(() => {
    this.localState.tooltipOpened = true;
  });


  onSearchItemsClear = (value) => {
    const itemsToDelete = this.localState.search.reportFilters.filter((option) => option.type === this.reverseCoreFilterNames[value]);
    this.localState.search.reportFilters = this.localState.search.reportFilters.filter(item => !itemsToDelete.includes(item));

  };

  onMultiSelectChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      this.localState.selectedOptions = [...this.localState.selectedOptions, value];
    } else {
      this.onSearchItemsClear(value);
    }
  };

  onSearchItemDelete = (value) => {
    this.localState.selectedOptions = this.localState.selectedOptions.filter((option) => option !== value);
    this.onSearchItemsClear(value);
    this.localState.search.filter_by[value] = JSON.parse(JSON.stringify(this.filterBy[value]));
  };

  onFilterByChange = (value, name) => {
    this.localState.search.filter_by[name] = value;
  };

  saveColumnPreset = async preset => {
    await this.actions.reportsActions.saveColumnPreset(preset);
  };

  updateTableFilters = () => {
    for (const searchRaw in this.localState.search.filter_by) {
      if (['panels', 'managers', 'teamleads', 'scouts', 'operators', 'levels', 'account-managers'].includes(searchRaw)) {
        this.onSearchItemsClear(searchRaw);
        this.localState.search.filter_by[searchRaw].forEach(data => {
          this.localState.search.reportFilters.push({
            type: this.reverseCoreFilterNames[searchRaw],
            label: this.filterNames[searchRaw],
            value: data
          });
        }
        );

      } else {
        const isFilterAlreadyExist = this.localState.search.reportFilters.find(
          f => f.type === this.reverseCoreFilterNames[searchRaw]);

        if (!isFilterAlreadyExist) {
          this.localState.search.reportFilters.push({
            type: this.reverseCoreFilterNames[searchRaw],
            value: this.localState.search.filter_by[searchRaw],
            label: this.filterNames[searchRaw],
            isServerSide: true
          });
        }

        if (this.localState.search.filter_by[searchRaw]) {
          this.localState.search.reportFilters = this.localState.search.reportFilters.map(item => (
            item.type === this.reverseCoreFilterNames[searchRaw] ?
              {
                type: item.type,
                value: this.localState.search.filter_by[searchRaw],
                label: item.label,
                isServerSide: true
              } :
              item));
        } else {
          const idx = this.localState.search.reportFilters.findIndex(
            f => f.type === this.reverseCoreFilterNames[searchRaw]);
          if (idx !== -1) {
            this.localState.search.reportFilters.splice(idx, 1);
          }
        }
      }
    }
  };

  onSearchChange = async searchString => {
    if (searchString.target) {
      this.localState.search.filter_by.all = searchString.target.value;
    } else {
      this.localState.search.filter_by.all = '';
    }
  };

  onSearchClick = async () => {
    this.localState.tooltipOpened = false;
    await this.onCreateReport();
    this.updateTableFilters();
  };

  onSearchFilterChange = searchString => {
    if (searchString.target) {
      this.localState.search.filter_by[searchString.target.name] = searchString.target.value;
    }
  };

  onChangeFilters = (found_filter) => {
    if (found_filter.is_new) {
      if (['panel', 'manager', 'form_level', 'team_lead', 'operator', 'account_manager', 'scout'].includes(found_filter.type)) {
        this.localState.search.filter_by[this.coreFilterNames[found_filter.type]].push(found_filter.value);
      } else {
        this.localState.search.filter_by[this.coreFilterNames[found_filter.type]] = found_filter.value;
      }
    } else {
      if (['panel', 'manager', 'form_level', 'team_lead', 'operator', 'account_manager', 'scout'].includes(found_filter.type)) {
        this.localState.search.filter_by[this.coreFilterNames[found_filter.type]] = this.localState.search.filter_by[
          this.coreFilterNames[found_filter.type]].filter(item => item !== found_filter.value);
      } else {
        this.localState.search.filter_by[this.coreFilterNames[found_filter.type]] = '';
        this.localState.search.reportFilters = this.localState.search.reportFilters.filter(
          item => item.value !== found_filter.value && item.type !== found_filter.type
        );
      }
    }
    this.updateTableFilters();
    localStorage.setItem(`reportLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  };

  onArchive = async () => {
    const { startDate, endDate } = this.store.reports.filters;
    try {
      await this.env.api.reportArchives.create(startDate, endDate);
      this.env.alert('Успех', 'Архивирование началось, процесс может занять некоторое время', 'success');
    } catch (e) {
      console.error(e);
      this.env.alert('Ошибка', 'Архивирование провалилось', 'error');
    }
  };

  onCreateReport = async () => {
    const { startDate, endDate } = this.store.reports.filters;
    try {
      this.localState.isTableLoading = true;
      const reports = await this.env.api.reports.fetchReports(
        startDate.toISOString(),
        endDate.toISOString(),
        this.localState.search.filter_by,
        this.localState.search.filter_by.all
      );

      this.actions.reportsActions.fetchReportsSuccess(reports.data);

    } catch (e) {
      this.actions.reportsActions.fetchReportsFailed();
      throw e;
    }

    this.localState.isTableLoading = false;
    this.store.reports.meta.in_process = null;
    localStorage.setItem(`reportLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  };

  onSortChange = (header, mode) => {
    if (mode === 'none') {
      this.lastSorting.delete(header);
    } else {
      this.lastSorting.set(header, mode);
    }
  };

  render() {
    const { filters, selectors, ui } = this.store.reports;
    const {
      setDates,
      changeGrouping,
      changeColumnPreset,
      changeColumnVisibility,
      changeRounding,
      changeSearch,
      changePresetOrder,
      deletePreset,
      toggleFavorite,
      toggleAllColumns
    } = this.actions.reportsActions;

    const isDecimalThunk = () => filters.isDecimal;

    let message = <div className='container' style={{
      width: '100%',
      margin: 'auto',
      background: 'aqua',
      padding: 30,
      fontWeight: 'bold',
      textAlign: 'center'
    }}> {this.store.reports.meta.in_process} % already LOADED </div>;
    let wait_message = this.store.reports.meta.in_process ? message : null;
    let archivateButton = this.store.auth.accessLevel === ACCESS_LEVEL.agency && (
      <div className='filter' style={{ verticalAlign: 'middle' }}>
        <button type='button' className='archive_button' onClick={this.onArchive}>
          Архивировать
        </button>
      </div>
    );

    return (
      <RouteLoading
        key='2'
        meta={this.store.reports.meta}
        render={() => (
          <div className='content'>
            <Navbar />
            <div className='under-navbar-content'>
              <TableFilter
                state={filters}
                selectors={selectors}
                onDatesChange={setDates}
                onGroupingChange={changeGrouping}
                onColumnPresetChange={changeColumnPreset}
                onColumnChange={changeColumnVisibility}
                onColumnPresetSubmit={this.saveColumnPreset}
                deletePreset={deletePreset}
                onIsFractionalChange={changeRounding}
                onSearchChange={changeSearch}
                withoutFilteringChange
                withoutGroupingChange={this.store.auth.accessLevel === ACCESS_LEVEL.operator}
                changePresetOrder={changePresetOrder}
                onAllColumnsToggle={toggleAllColumns}
                getTableNode={() => this.node}
                currentPageMode={this.localState.pageMode}
                withoutStatusChange
                withSearch={false}
                withCustomSearch={true}
                withColumnsConfigure={true}
                render={() =>
                  [<div key={''} style={{ display: 'flex' }}>
                    <div>
                      <ReportFilterTooltip
                        isOpen={this.localState.tooltipOpened}
                        onRequestClose={this.onSearchTooltipClose}
                        onStatusChange={value => (this.localState.search.status = value)}
                        current_status={this.localState.search.status || 'active'}
                        options={this.localState.reportModalOptions}
                        onSearchClick={this.onSearchClick}
                        selectedOptions={this.localState.selectedOptions}
                        onSearchItemDelete={this.onSearchItemDelete}
                        onReportModalOpen={this.onReportModalOpen}
                        filter_by={this.localState.search.filter_by}
                        onFilterByChange={this.onFilterByChange}
                        onLastSearchChange={this.onSearchFilterChange}
                        filterNames={this.filterNames}
                        onSearchTooltipOpen={this.onSearchTooltipOpen}
                        onSearchChange={this.onSearchChange}
                        levelOptions={this.levelOptions}
                        initialSortingMap={this.lastSorting}
                      >
                      </ReportFilterTooltip>
                    </div>
                    <div style={{ verticalAlign: 'middle' }}>
                      <button type='button' className='archive_button' onClick={this.onCreateReport}>
                        ОТЧЁТ
                      </button>
                    </div>
                    {archivateButton}
                  </div>
                  ]
                }
              />
              {wait_message}
              <div className='container'>
                <div className='inner'>
                  <div className='inner-scroll reports-table'>
                    <Observer>
                      {() =>
                        selectors.filteredData.map((table, idx) => (
                          <DataTable
                            headerSticky={selectors.filteredData.length > 1 ? false : 70}
                            ref={node => (this.node = node)}
                            key={idx}
                            data={table}
                            tableFiltersKey='reports-filters'
                            columnSettings={filters.columnSettings}
                            favorites={ui.favorites}
                            toggleFavorite={toggleFavorite}
                            isDecimalThunk={isDecimalThunk}
                            requestModalOpen={this.onModalOpen}
                            selectors={selectors}
                            initialSortingMap={{ total: 'desc' }}
                            loading={this.localState.isTableLoading}
                            onSortChange={this.onSortChange}
                            name={'reports'}
                            onRemoveFilter={this.onChangeFilters}
                            onAddFilter={this.onChangeFilters}
                            onSearchClick={this.onSearchClick}
                            account_filters={this.localState.search.reportFilters}
                          />
                        ))
                      }
                    </Observer>
                    <Observer>
                      {() => (
                        <GeneralAccountModal
                          isOpened={this.localState.isModalOpened}
                          requestClose={this.onModalClose}
                          accountId={this.localState.selectedProfileId}
                        />
                      )}
                    </Observer>
                    <Observer>
                      {() => (
                        <ReportModal
                          isOpen={this.localState.isReportModalOpened}
                          onRequestClose={this.onReportModalClose}
                          options={this.localState.reportModalOptions}
                          selectedOptions={this.localState.selectedOptions}
                          handleChange={this.onMultiSelectChange}
                        />
                      )}
                    </Observer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

export default Component({ namespaces: ['common'] })(ReportsPage);
